import { Formik, FormikProps } from "formik";
import React, { FC, memo } from "react";
import * as Yup from "yup";

import { VALIDATION_TYPES } from "@/components/Formik";
import { FormikForm } from "@/formikComponents";
import { profilePartialUpdaterBuilder } from "@/views/ConsultantProfiles/Detail/profilePartialUpdaterBuilder";
import {
  ISkillsFormikProps,
  ISkillsFormSectionValues,
  SkillsFormComponent,
  validationSkillsFormSchema as validationSchema,
} from "@/views/ConsultantProfiles/Detail/SkillsSection/SkillsForm";

import { Buttons } from "./Buttons";

const Form: FC<ISkillsFormikProps> = memo(({ initialValues, validationSchema: vs, onSubmit, onCancel, ...rest }) => {
  const isPrivateProfile = !rest.source.companyRole;

  const skillsSchema = Yup.object().shape({
    skills: Yup.array().of(Yup.object()).min(1, VALIDATION_TYPES.ARRAY_MORE_THAN),
  });

  const finalValidationSchema = !isPrivateProfile ? validationSchema : validationSchema.concat(skillsSchema);

  return (
    <Formik initialValues={initialValues} validationSchema={finalValidationSchema} onSubmit={onSubmit}>
      {(form: FormikProps<ISkillsFormSectionValues>) => (
        <>
          <FormikForm>
            <SkillsFormComponent {...rest} form={form} />
            <Buttons form={form} onClose={onCancel} />
          </FormikForm>
        </>
      )}
    </Formik>
  );
});

export const SkillsFormik = profilePartialUpdaterBuilder(Form, {
  validationSchema,
  messengerContext: "",
});
